import {inject, injectable} from 'inversify';

import {logger} from '../../../utils/logger';
import {FetchCategoriesQuery} from '../../ports/Category/FetchCategories/FetchCategories.query';

@injectable()
export class FetchCategoriesUseCase {
  constructor(
    @inject(FetchCategoriesQuery) private readonly query: FetchCategoriesQuery,
  ) {}

  execute(params?: FetchCategoriesQuery.Params) {
    try {
      return this.query.fetch(params);
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}
